// src/pages/Settings.js
import React from "react";

export default function Settings() {
  return (
    <div className="settings-page">
      <h2>Settings</h2>
      <div className="card">
        <h3>Preferences</h3>
        <p>Default currency, notification preferences, and theme settings will appear here.</p>
      </div>
    </div>
  );
}